import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import TermsOfService from '../components/TermsOfService';

const PageContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
  max-width: 900px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
`;

const BackButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  padding: 12px 24px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  text-decoration: none;
  border-radius: 25px;
  font-weight: 500;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateY(-2px);
  }

  &:before {
    content: '←';
    margin-right: 8px;
    font-size: 16px;
  }
`;

const Title = styled.h1`
  color: white;
  font-size: 28px;
  font-weight: 600;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
`;

const ContentContainer = styled.div`
  flex: 1;
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  background: white;
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

const TermsPage: React.FC = () => {
  return (
    <PageContainer>
      <Header>
        <BackButton to="/">返回首页</BackButton>
        <Title>服务条例</Title>
        <div style={{ width: '120px' }} /> {/* Spacer for centering */}
      </Header>
      <ContentContainer>
        <TermsOfService />
      </ContentContainer>
    </PageContainer>
  );
};

export default TermsPage;
